module.exports = __webpack_public_path__ + "media/images/emblems/Glattfelden-blazon-358982f845ed01e1fb4e5318d2dadd7e.svg";